import React, { useState } from "react";

import { useQuery } from "@apollo/react-hooks";
import { GET_BATCH_QUEUE_STATUS } from "../queries";

const useBatchQueueStatus = () => {
    const [photoSubmissionBalance, setPhotoSubmissionBalance] = useState(0);

    useQuery(GET_BATCH_QUEUE_STATUS, {
        onCompleted: ({
            photoBatchQueueStatus: { photoSubmissionBalance }
        }) => {
            setPhotoSubmissionBalance(photoSubmissionBalance);
        }
    });

    return {
        photoSubmissionBalance
    };
};

export default useBatchQueueStatus;
